export default __webpack_public_path__ + "static/media/healthIns2.f956b5ca.jpg";